import { render } from "./OnboardingCarousel.vue?vue&type=template&id=5ec6221e&scoped=true"
import script from "./OnboardingCarousel.vue?vue&type=script&lang=js"
export * from "./OnboardingCarousel.vue?vue&type=script&lang=js"

import "./OnboardingCarousel.vue?vue&type=style&index=0&id=5ec6221e&scoped=true&lang=css"

import exportComponent from "/Users/georgwidschwendter/Documents/GitHub/learn/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec6221e"]])

export default __exports__